export function convertToWebcalUrl(url: string) {
  return url.replace(/^http/, 'webcal')
}
